import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useDispatch } from 'react-redux';
import { loginWithGoogle } from '../../store/authSlice';

function GoogleLoginButton({ onSuccess, onError }) {
  const dispatch = useDispatch();

  const handleSuccess = async (credentialResponse) => {
    const result = await dispatch(loginWithGoogle(credentialResponse.credential));
    if (loginWithGoogle.fulfilled.match(result)) {
      onSuccess?.();
    } else {
      onError?.(result.payload || 'Google sign-in failed');
    }
  };

  const handleError = () => {
    onError?.('Google sign-in was cancelled or failed');
  };

  return (
    <GoogleLogin
      onSuccess={handleSuccess}
      onError={handleError}
      useOneTap={false}
      width="100%"
    />
  );
}

export default GoogleLoginButton;
